// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/image/logo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-style {
  font-size: 35px;
  display: flex;
  top: 10%;
  position: absolute;
  text-align: center;
  color: black;
  white-space: pre-line;
}

.card {
  display: flex;
  box-shadow: 0px 8px 8px 2px rgba(0, 0, 0, 0.25);
  width: 400px;
  height: 284.89px;
  flex-shrink: 0;
  background: #212121;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  color: #ccc;
  border-radius: 10px;
}

span {
  position: absolute;
  border-radius: 100vmax;
}

.top {
  top: 0;
  left: 0;
  width: 0;
  height: 2px;
}

.bottom {
  right: 0;
  bottom: 0;
  height: 2px;
}

.right {
  top: 0;
  right: 0;
  width: 2px;
  height: 0;
}

.left {
  left: 0;
  bottom: 0;
  width: 2px;
  height: 0;
}

.top {
  animation: animateTop 7s ease-in-out infinite;
}

.bottom {
  animation: animateBottom 7s ease-in-out infinite;
}

.right {
  animation: animateRight 7s ease-in-out infinite;
}

.left {
  animation: animateLeft 7s ease-in-out infinite;
}

@keyframes animateTop {
  25% {
    width: 100%;
    opacity: 1;
  }

  30%,
  100% {
    opacity: 0;
  }
}

@keyframes animateBottom {
  0%,
  50% {
    opacity: 0;
    width: 0;
  }

  75% {
    opacity: 1;
    width: 100%;
  }

  76%,
  100% {
    opacity: 0;
  }
}

@keyframes animateRight {
  0%,
  25% {
    opacity: 0;
    height: 0;
  }

  50% {
    opacity: 1;
    height: 100%;
  }

  55%,
  100% {
    height: 100%;
    opacity: 0;
  }
}

@keyframes animateLeft {
  0%,
  75% {
    opacity: 0;
    bottom: 0;
    height: 0;
  }

  100% {
    opacity: 1;
    height: 100%;
  }
}

.card-head {
  display: flex;
  width: 350px;
  justify-content: flex-start;
  align-items: center;
  gap: 25px;
  margin: 0% 0 10% 5%;
}

.card-h2 {
  font-family: Ubuntu;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1px;
  margin-top: 2%
}

.card-icon {
  display: flex;
  justify-content: center;
  color: #659df2f3;
}

.card-p {
  display: flex;
  width: 350px;
  height: 60px;
  flex-direction: column;
  justify-content: center;
  color: #ccc;
  margin-bottom: 0;
  font-family: Ubuntu;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  letter-spacing: 0.6px;
  margin-left: 5%;
  margin-top: -5%;
}

.tag {
  display: flex;
  width: 157px;
  height: 31px;
  border-radius: 5px;
  border: none;

  text-align: center;
  font-family: Ubuntu;
  font-size: 19px;
  font-weight: 500;
  letter-spacing: 1.2px;
  justify-content: center;
  align-items: flex-end;
  text-decoration: none;
  margin-left: 50%;
}

.tag:before,
.tag:hover {
  box-shadow: 0px 3px 3px 1px #131414;
}

.container-2 {
  display: flex;
  width: 100%;
  height: auto;
  padding: 5%;

  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5rem;
  background: none;
}

.bot-card {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 10%;
  flex-direction: column;
}

.create-admin {
  position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.m-size {
  width: 20px;
  height: 20px;
  size: 20px;
  margin-left: 5px;
  text-align: center;
}
.buttonLogout {
  position: relative;
  display: flexbox;
  justify-content: center;
  /* margin-left: -10%; */
  margin: 2% 45%;
  padding: 0.5rem 1.2rem;
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.25);
  background: #272727;
  border: none;
  border-radius: 5px;
  color: #ccc;
}
.buttonLogout:hover {
  box-shadow: 0px 0px 1px 1px #ddaa0391;
}
@media (width < 1200px) {
  .buttonLogout {
    margin: 2% 40%;
  }
  .admin-modal {
    margin-left: -55%;
  }
}
@media (width < 600px) {
  .buttonLogout {
    margin: 2% 35%;
  }
  .admin-modal {
    margin-left: -55%;
  }
}
.link {
  text-decoration: underline;
  color: #ffffff;
  letter-spacing: 0.8px;
  border: none;
  background: none;
  outline: none;
}

.link:hover,
.link:not(:focus),
.link:not(:active) {
  outline: none;
  border: none;
}

.img-logo-admin {
  margin: 27px 0 32px 0;
  padding: 28px;
  color: #ebce2c;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/bots/bots.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,UAAU;EACV,SAAS;AACX;;AAEA;EACE,OAAO;EACP,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,SAAS;IACT,SAAS;EACX;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;;EAEZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,WAAW;;EAEX,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,+CAA+C;EAC/C,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qCAAqC;AACvC;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,yDAAkD;EAClD,0BAA0B;AAC5B","sourcesContent":[".header-style {\n  font-size: 35px;\n  display: flex;\n  top: 10%;\n  position: absolute;\n  text-align: center;\n  color: black;\n  white-space: pre-line;\n}\n\n.card {\n  display: flex;\n  box-shadow: 0px 8px 8px 2px rgba(0, 0, 0, 0.25);\n  width: 400px;\n  height: 284.89px;\n  flex-shrink: 0;\n  background: #212121;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 30px;\n  color: #ccc;\n  border-radius: 10px;\n}\n\nspan {\n  position: absolute;\n  border-radius: 100vmax;\n}\n\n.top {\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 2px;\n}\n\n.bottom {\n  right: 0;\n  bottom: 0;\n  height: 2px;\n}\n\n.right {\n  top: 0;\n  right: 0;\n  width: 2px;\n  height: 0;\n}\n\n.left {\n  left: 0;\n  bottom: 0;\n  width: 2px;\n  height: 0;\n}\n\n.top {\n  animation: animateTop 7s ease-in-out infinite;\n}\n\n.bottom {\n  animation: animateBottom 7s ease-in-out infinite;\n}\n\n.right {\n  animation: animateRight 7s ease-in-out infinite;\n}\n\n.left {\n  animation: animateLeft 7s ease-in-out infinite;\n}\n\n@keyframes animateTop {\n  25% {\n    width: 100%;\n    opacity: 1;\n  }\n\n  30%,\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes animateBottom {\n  0%,\n  50% {\n    opacity: 0;\n    width: 0;\n  }\n\n  75% {\n    opacity: 1;\n    width: 100%;\n  }\n\n  76%,\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes animateRight {\n  0%,\n  25% {\n    opacity: 0;\n    height: 0;\n  }\n\n  50% {\n    opacity: 1;\n    height: 100%;\n  }\n\n  55%,\n  100% {\n    height: 100%;\n    opacity: 0;\n  }\n}\n\n@keyframes animateLeft {\n  0%,\n  75% {\n    opacity: 0;\n    bottom: 0;\n    height: 0;\n  }\n\n  100% {\n    opacity: 1;\n    height: 100%;\n  }\n}\n\n.card-head {\n  display: flex;\n  width: 350px;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 25px;\n  margin: 0% 0 10% 5%;\n}\n\n.card-h2 {\n  font-family: Ubuntu;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 1px;\n  margin-top: 2%\n}\n\n.card-icon {\n  display: flex;\n  justify-content: center;\n  color: #659df2f3;\n}\n\n.card-p {\n  display: flex;\n  width: 350px;\n  height: 60px;\n  flex-direction: column;\n  justify-content: center;\n  color: #ccc;\n  margin-bottom: 0;\n  font-family: Ubuntu;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: normal;\n  letter-spacing: 0.6px;\n  margin-left: 5%;\n  margin-top: -5%;\n}\n\n.tag {\n  display: flex;\n  width: 157px;\n  height: 31px;\n  border-radius: 5px;\n  border: none;\n\n  text-align: center;\n  font-family: Ubuntu;\n  font-size: 19px;\n  font-weight: 500;\n  letter-spacing: 1.2px;\n  justify-content: center;\n  align-items: flex-end;\n  text-decoration: none;\n  margin-left: 50%;\n}\n\n.tag:before,\n.tag:hover {\n  box-shadow: 0px 3px 3px 1px #131414;\n}\n\n.container-2 {\n  display: flex;\n  width: 100%;\n  height: auto;\n  padding: 5%;\n\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 5rem;\n  background: none;\n}\n\n.bot-card {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 10%;\n  flex-direction: column;\n}\n\n.create-admin {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.m-size {\n  width: 20px;\n  height: 20px;\n  size: 20px;\n  margin-left: 5px;\n  text-align: center;\n}\n.buttonLogout {\n  position: relative;\n  display: flexbox;\n  justify-content: center;\n  /* margin-left: -10%; */\n  margin: 2% 45%;\n  padding: 0.5rem 1.2rem;\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.25);\n  background: #272727;\n  border: none;\n  border-radius: 5px;\n  color: #ccc;\n}\n.buttonLogout:hover {\n  box-shadow: 0px 0px 1px 1px #ddaa0391;\n}\n@media (width < 1200px) {\n  .buttonLogout {\n    margin: 2% 40%;\n  }\n  .admin-modal {\n    margin-left: -55%;\n  }\n}\n@media (width < 600px) {\n  .buttonLogout {\n    margin: 2% 35%;\n  }\n  .admin-modal {\n    margin-left: -55%;\n  }\n}\n.link {\n  text-decoration: underline;\n  color: #ffffff;\n  letter-spacing: 0.8px;\n  border: none;\n  background: none;\n  outline: none;\n}\n\n.link:hover,\n.link:not(:focus),\n.link:not(:active) {\n  outline: none;\n  border: none;\n}\n\n.img-logo-admin {\n  margin: 27px 0 32px 0;\n  padding: 28px;\n  color: #ebce2c;\n  background-image: url(../../assets/image/logo.svg);\n  background-size: 100% 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
